import { rootMargin } from '@helpers/animate';
import { getSrcs, imageUrl } from '@helpers/image';
import { Device, until } from '@helpers/media';
import { withMotion } from '@hoc/withMotion';
import { useInView } from '@hooks/useInView';
import ShareLinks from '@stories/Components/Misc/ShareLinks/ShareLinks';
import React from 'react';
import { ArticleBannerStyles as S } from './ArticleBanner.styles';
import { Icon, getSvgIcon } from '@helpers/icons';
const ArticleBanner = ({ brandingLogo, date, title, intro, image, tags, shareButtons, pageContext, translations, url, }) => {
    const srcs = image ? getSrcs(image, 948, 336, 5, 948 / 495) : undefined;
    const sizes = `${until(Device.TabletLarge)} 336px, 948px`;
    const [containerRef, inView] = useInView({ rootMargin }, false, pageContext?.isEditMode);
    return (React.createElement(S.MotionWrapper, { "data-in-view": inView },
        React.createElement(S.Container, { ref: containerRef, flush: image ? 'both' : undefined, variant: 'stone' },
            React.createElement(S.TopSection, { "data-has-image": !!image },
                React.createElement(S.BackgroundIcon, null, getSvgIcon(Icon.BrandFlower)),
                React.createElement(S.Content, null,
                    brandingLogo && (React.createElement(S.BrandingLogo, null,
                        React.createElement("img", { src: imageUrl(brandingLogo, { height: 50 }), loading: "eager", alt: brandingLogo.altText, role: !brandingLogo.altText ? 'presentation' : undefined }))),
                    date && React.createElement(S.Date, null, new Date(date).toDateString()),
                    React.createElement(S.Title, null, title),
                    intro && React.createElement(S.Intro, { dangerouslySetInnerHTML: { __html: intro } })),
                image && srcs && (React.createElement(S.ImageWrapper, null,
                    React.createElement("img", { src: srcs.src, srcSet: srcs.srcSet, sizes: sizes, loading: "eager", alt: image.altText, role: !image.altText ? 'presentation' : undefined }))))),
        React.createElement(S.BottomSection, null,
            React.createElement(S.TextWithSection, { "data-stacked-mobile": true },
                React.createElement(S.SectionText, null, translations?.['article-banner.tags'] ?? 'Tags:'),
                React.createElement(S.Tags, null, tags.map((tag) => (React.createElement(S.Tag, { key: tag.id }, tag.name))))),
            React.createElement(S.TextWithSection, null,
                React.createElement(S.SectionText, { "data-show-pointer": true, onClick: () => {
                        if ('share' in window.navigator) {
                            navigator.share({
                                url: window.location.toString(),
                                title: document.title,
                            });
                        }
                    } }, translations?.['article-banner.share'] ?? 'Share:'),
                React.createElement(S.ShareLinksWrapper, null,
                    React.createElement(ShareLinks, { icons: shareButtons, url: url, pageName: title }))))));
};
export default withMotion(ArticleBanner);
